import animate, { ANIMATION_TYPE, type AnimationOptions } from "@client/lib/jquery/animate";
import { makeWith, makeWrap } from "./factory";

export interface AnimationProps {
  animationOptions: Partial<AnimationOptions>;
}

export const withAnimate = makeWith<AnimationProps>(
  (element: HTMLElement, props: AnimationProps) => animate(element, props.animationOptions),
  "animationOptions",
  (props) => (props.animationOptions?.type === ANIMATION_TYPE.None ? undefined : "animated")
);

const animateTag = makeWrap<AnimationProps>(withAnimate);
export default animateTag;

export const AnimatedDiv = animateTag<HTMLDivElement>("div");
